import { LoadingButton } from "@mui/lab";
import { Stack, TextField } from "@mui/material";
import { format } from "date-fns";
import { useSubscriptionEditDuration } from "hooks/api/useSubscriptionEditDuration";
import { useState } from "react";

export const EditDurationForm = ({ startAt, endAt, subscriptionId }) => {
    const { editDuration, isLoading } = useSubscriptionEditDuration();

    const [selectedEndDate, setSelectedEndDate] = useState(
        format(new Date(endAt), "yyyy-MM-dd"),
    );

    const handleChangeEndDate = (event) => {
        setSelectedEndDate(event.target.value);
    };

    const handleUpdateDuration = () => {
        if (new Date(selectedEndDate) > new Date(startAt)) {
            const formattedStartDate = format(new Date(startAt), "yyyy-MM-dd");
            const formattedEndDate = format(
                new Date(selectedEndDate),
                "yyyy-MM-dd",
            );
            editDuration({
                startDate: formattedStartDate,
                endDate: formattedEndDate,
                subscriptionId,
            });
        }
    };

    return (
        <Stack direction="row" gap={2} p={2} alignItems="center">
            <TextField
                InputLabelProps={{
                    shrink: true,
                }}
                disabled={true}
                value={format(new Date(startAt), "yyyy-MM-dd")}
                type="date"
                size="small"
                label="Start date"
                variant="standard"
            />
            <TextField
                InputLabelProps={{
                    shrink: true,
                }}
                value={selectedEndDate}
                onChange={handleChangeEndDate}
                type="date"
                size="small"
                label="End date"
                variant="standard"
            />
            <LoadingButton
                loading={isLoading}
                onClick={handleUpdateDuration}
                size="small"
                color="primary"
                variant="contained"
                sx={{
                    px: "1rem",
                }}
            >
                Change Duration
            </LoadingButton>
        </Stack>
    );
};
export default EditDurationForm;
